// extracted by mini-css-extract-plugin
export default {"LoggingInLoadingOverlay":"LoggingInLoadingOverlay_LoggingInLoadingOverlay__NnD8z"};